"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyChooseDJEntertainment() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: image2Ref,
    isVisible: image2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: image3Ref,
    isVisible: image3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: heading1Ref,
    isVisible: heading1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: text1Ref,
    isVisible: text1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: heading2Ref,
    isVisible: heading2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: text2Ref,
    isVisible: text2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: heading3Ref,
    isVisible: heading3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: text3Ref,
    isVisible: text3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="relative overflow-hidden bg-background py-16 md:py-24">
      {}
      <div className="absolute inset-0 opacity-10 transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] hover:translate-x-4" style={{
      backgroundImage: "repeating-linear-gradient(45deg, hsl(0, 0%, 50%) 0px, hsl(0, 0%, 50%) 20px, transparent 20px, transparent 40px, hsl(0, 0%, 0%) 40px, hsl(0, 0%, 0%) 60px, transparent 60px, transparent 80px)"
    }} />

      <div className="container relative z-10 mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
          {}
          <div className="flex flex-col space-y-8">
            <div ref={imageRef} className={`-mt-20 flex items-center justify-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${imageVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
              <div className="group relative overflow-hidden rounded-lg shadow-strong">
                <img src="https://talented-bat.10web.cloud/wp-content/uploads/2025/11/dj-pic.jpg" alt="Derek Johnson - Lead DJ at D&J Entertainment" className="h-auto w-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-105" />
              </div>
            </div>

            {}
            <div ref={image2Ref} className={`mt-12 flex items-center justify-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${image2Visible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
              <div className="group relative overflow-hidden rounded-lg shadow-strong">
                <img src="https://talented-bat.10web.cloud/wp-content/uploads/2025/11/dj-pic-2.jpg" alt="Professional DJ equipment and setup" className="h-auto w-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-105" />
              </div>
            </div>

            {}
            <div ref={image3Ref} className={`mt-12 flex items-center justify-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${image3Visible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
              <div className="group relative overflow-hidden rounded-lg shadow-strong">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1448648/img/image_zlh2lpry.jpg" alt="D&J Entertainment event performance" className="h-auto w-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-105" />
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col justify-center space-y-8">
            {}
            <div ref={heading1Ref} className={`transition-all duration-[var(--duration-slow)] delay-100 ease-[var(--ease-out-back)] ${heading1Visible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
              <h2 className="font-display text-3xl font-bold text-foreground md:text-4xl lg:text-5xl">
                Why Choose D&J Entertainment?
              </h2>
            </div>

            <div ref={text1Ref} className={`transition-all duration-[var(--duration-slow)] delay-200 ease-[var(--ease-out-back)] ${text1Visible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
              <p className="text-lg font-semibold leading-relaxed text-foreground">
                Over a DECADE of professional DJ experience bringing NON-STOP energy to every single event! We're not just playing music—we're creating ELECTRIC, interactive performances that'll blow your mind and leave your guests talking about YOUR party for YEARS! From the first beat drop to the last song, we guarantee an UNFORGETTABLE experience that matches your vision PERFECTLY! 🎉💥
              </p>
            </div>

            {}
            <div ref={heading2Ref} className={`transition-all duration-[var(--duration-slow)] delay-300 ease-[var(--ease-out-back)] ${heading2Visible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
              <h3 className="font-display text-2xl font-semibold text-primary md:text-3xl">
                Personalized Service
              </h3>
            </div>

            <div ref={text2Ref} className={`transition-all duration-[var(--duration-slow)] delay-400 ease-[var(--ease-out-back)] ${text2Visible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
              <p className="text-lg font-semibold leading-relaxed text-foreground">
                Your event, YOUR soundtrack! We craft killer custom playlists that'll have everyone from your grandma to your college buddies tearing up the dance floor! Whether it's a romantic wedding or a wild corporate bash, we've got thousands of tracks spanning EVERY genre imaginable—let's make your party absolutely LEGENDARY! 🎵🔥
              </p>
            </div>

            {}
            <div ref={heading3Ref} className={`transition-all duration-[var(--duration-slow)] delay-500 ease-[var(--ease-out-back)] ${heading3Visible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
              <h3 className="font-display text-2xl font-semibold text-secondary md:text-3xl">
                High-Quality Experience
              </h3>
            </div>

            <div ref={text3Ref} className={`transition-all duration-[var(--duration-slow)] delay-600 ease-[var(--ease-out-back)] ${text3Visible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
              <p className="text-lg font-semibold leading-relaxed text-foreground">
                We bring TOP-TIER professional sound and lighting equipment that'll transform ANY venue into an EPIC party atmosphere! Combined with our rock-solid reliability and punctual service, you'll get a FLAWLESS, stress-free experience from start to finish! Your satisfaction is our NUMBER ONE priority—we're 100% committed to making your event TRULY SPECTACULAR! 🎊✨
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}